import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSuccessMarkDone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
      fill="url(#success-mark-done_svg__a)"
    />
    <path
      d="m6.09 12.42 5.057 5.059L18.71 7.88"
      stroke="#fff"
      strokeWidth={2}
    />
    <defs>
      <linearGradient
        id="success-mark-done_svg__a"
        x1={24}
        y1={24}
        x2={24}
        y2={0}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E04B" />
        <stop offset={0.972} stopColor="#00B0B6" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgSuccessMarkDone);
export default Memo;
